import { Link, LinkButton, type LinkButtonProps, type LinkProps } from "./Link";
import { isChrome, isEdge } from "~/common/utils/browserChecks";
import { forwardRef } from "react";
import DownloadIcon from "@mui/icons-material/Download";

export const DownloadUrlLink = forwardRef<HTMLAnchorElement, Omit<LinkProps, "iconBefore">>((props, ref) => (
  <Link ref={ref} iconBefore={<DownloadIcon  />} {...props} />
));

export const DownloadClickLink = forwardRef<HTMLButtonElement, Omit<LinkButtonProps, "iconBefore">>((props, ref) => (
  <LinkButton ref={ref} iconBefore={<DownloadIcon  />} {...props} />
));

const skipDownloadParam = isChrome() || isEdge();
export const getDownloadProperty = (filename: string) => (skipDownloadParam ? undefined : filename);
